import { IconButton, Menu, MoreIcon, Popover, Table } from "evergreen-ui";
import React from "react";

interface IProps {
  item: any;
}

const AdminBrandArticleRow: React.FC<IProps> = ({ item }) => {
  return (
    <Table.Row>
      <Table.TextCell>{item.name}</Table.TextCell>
      <Table.TextCell>{item.sequence}</Table.TextCell>
      <Table.Cell>
        <Popover
          content={({ close }) => (
            <Menu>
              <Menu.Group title="Actions">
                <Menu.Item>Edit</Menu.Item>
                <Menu.Item intent="danger">Delete</Menu.Item>
              </Menu.Group>
            </Menu>
          )}
        >
          <IconButton appearance="minimal" icon={MoreIcon} />
        </Popover>
      </Table.Cell>
    </Table.Row>
  );
};

export default AdminBrandArticleRow;
